module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "media-list"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/contentSection'
      }
    }
  }, [_vm._v("内容专区运营")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("分享记录")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tableList"
  }, [_c('el-form', {
    staticClass: "searchForm",
    attrs: {
      "inline": true,
      "model": _vm.formContent
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "分享版块"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formContent.name),
      callback: function($$v) {
        _vm.$set(_vm.formContent, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formContent.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邀请码类型",
      "label-width": "120px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.formContent.type),
      callback: function($$v) {
        _vm.$set(_vm.formContent, "type", $$v)
      },
      expression: "formContent.type"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "兑换码"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formContent.couponSN),
      callback: function($$v) {
        _vm.$set(_vm.formContent, "couponSN", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formContent.couponSN"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.onQuery
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btnRight",
    staticStyle: {
      "text-align": "right",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.importEquity
    }
  }, [_vm._v("导入权益")])], 1), _vm._v(" "), _c('Card', [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("分享记录")]), _vm._v(" "), _c('div', {
    staticClass: "tableToList"
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": _vm.rowClass,
      "data": _vm.queryData
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "createdAt",
      "label": "分享版块",
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm._l((scope.row.goodsInfo), function(item, index) {
          return _c('el-tooltip', {
            key: index,
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "placement": "top-start"
            }
          }, [_vm._l((scope.row.goodsInfo), function(item2, index) {
            return _c('span', {
              key: index,
              attrs: {
                "slot": "content"
              },
              slot: "content"
            }, [_vm._v("\n                    " + _vm._s(item2.sectionName) + "\n                  ")])
          }), _vm._v(" "), _c('p', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (index < 2),
              expression: "index < 2"
            }]
          }, [_vm._v("\n                    " + _vm._s(item.sectionName) + "\n                  ")])], 2)
        })
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createdAt",
      "label": "生成时间",
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("formatDate2")(scope.row.createdAt)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "邀请码类型",
      "align": "center",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.type == 1) ? _c('span', [_vm._v("邀请码")]) : _vm._e(), _vm._v(" "), (scope.row.type == 2) ? _c('span', [_vm._v("专享码")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lable",
      "label": "使用期限",
      "align": "center",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(!scope.row.isSecDeleted) ? _c('span', [_vm._v(_vm._s(_vm._f("formatDate3")(scope.row.startTime)) + " ——\n                  " + _vm._s(_vm._f("formatDate3")(scope.row.endTime)))]) : _c('span', [_vm._v("无")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "align": "center",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "usedCnt",
      "label": "领取人数",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("getUsedCnt")(scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "categoryId",
      "label": "操作",
      "align": "center",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "编辑",
            "placement": "top"
          }
        }, [(
          scope.row.name != '批量导入' && !scope.row.isSecDeleted
        ) ? _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('el-tooltip', {
          attrs: {
            "content": "详情",
            "placement": "top"
          }
        }, [_c('el-button', {
          staticStyle: {
            "background-color": "#009e7d"
          },
          attrs: {
            "type": "info",
            "size": "mini",
            "icon": "el-icon-document"
          },
          on: {
            "click": function($event) {
              return _vm.handleInvitationDetail(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "pagination-box",
    staticStyle: {
      "padding": "30px 0px 30px 0px !important"
    }
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "preShare",
    attrs: {
      "title": "导入权益样式",
      "visible": _vm.centerDialogVisible,
      "width": "45%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "header-cell-style": _vm.rowClass,
      "data": _vm.templateList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "分享版块名称",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "align": "center",
      "min-width": "150"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("功能说明")]), _vm._v(" "), _c('p', [_vm._v("1，手机号兑换表格内填写的版块")]), _vm._v(" "), _c('p', [_vm._v("2，多个版块可填写同一手机号，将关联多个版块内容生成权益")]), _vm._v(" "), _c('p', [_vm._v("\n      3，同一手机号仅能在表格里导入一次生产的兑换码生效，多次导入重复的手机号会去筛除\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      4，用户在设备兑换时，输入品牌代称字母+手机号后7位即可兑换（可在兑换记录里查询）\n    ")]), _vm._v(" "), _c('p', [_vm._v("5，品牌代称字母，联系开放平台工作人员获得")]), _vm._v(" "), _c('p', [_vm._v("6，仅支持.excel文件导入")]), _vm._v(" "), _c('el-upload', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "action": "/edu/eduAdmin/hxd/batch_import_right",
      "accept": ".xlsx, .xls",
      "before-upload": _vm.onBeforeUpload,
      "on-success": _vm.onSuccessUpload,
      "on-error": _vm.onErrorUpload,
      "data": _vm.uploadData,
      "show-file-list": true
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("\n        立即导入\n        "), _c('i', {
    staticClass: "el-icon-upload el-icon--right"
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑运营内容",
      "visible": _vm.dialogVisible,
      "width": "60%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.formInvitation,
      "label-width": "125px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "*邀请码类型"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formInvitation.code),
      callback: function($$v) {
        _vm.$set(_vm.formInvitation, "code", $$v)
      },
      expression: "formInvitation.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.formInvitation.valueTo == 1 ? '人数' : '*SN数量'
    }
  }, [(_vm.formInvitation.valueTo == 1) ? _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formInvitation.peopleNumTo),
      callback: function($$v) {
        _vm.$set(_vm.formInvitation, "peopleNumTo", $$v)
      },
      expression: "formInvitation.peopleNumTo"
    }
  }, _vm._l((_vm.peopleNum), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.formInvitation.valueTo != 1) ? _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.formInvitation.peopleNumToSelf),
      callback: function($$v) {
        _vm.$set(_vm.formInvitation, "peopleNumToSelf", $$v)
      },
      expression: "formInvitation.peopleNumToSelf"
    }
  }, _vm._l((_vm.peopleNumSelf), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.formInvitation.valueTo == 1 ? '使用时限' : '*兑换时限'
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "180px",
      "font-size": "10px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formInvitation.startTime),
      callback: function($$v) {
        _vm.$set(_vm.formInvitation, "startTime", $$v)
      },
      expression: "formInvitation.startTime"
    }
  }), _vm._v("\n        至\n        "), _c('el-date-picker', {
    staticStyle: {
      "width": "180px",
      "font-size": "10px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.formInvitation.endTime),
      callback: function($$v) {
        _vm.$set(_vm.formInvitation, "endTime", $$v)
      },
      expression: "formInvitation.endTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "textarea",
      "rows": 3
    },
    model: {
      value: (_vm.formInvitation.remark),
      callback: function($$v) {
        _vm.$set(_vm.formInvitation, "remark", $$v)
      },
      expression: "formInvitation.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "background-color": "#009e7d",
      "color": "#ffffff",
      "margin-bottom": "20px"
    },
    on: {
      "click": _vm.editInvitation
    }
  }, [_vm._v("\n      " + _vm._s(_vm.formInvitation.valueTo == 1 ? "编辑邀请码" : "编辑专享码") + "\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right",
      "margin-top": "-40px"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02c44f81","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/prefectureShare.vue
// module id = 651
// module chunks = 1